import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import ErrorAlert from '../Alerts/ErrorAlert';
import { ExcelModuleFechtAPI } from '../../api/ExcelModule';
import { TaxesFetchAPI } from '../../api/Taxes';

function ModalImport({ setEventHandler }) {
    const [showModal, setShowModal] = useState(false);
    const [productsFile, setProductsFile] = useState(null);
    const [optionalsFile, setOptionalsFile] = useState(null);
    const [taxId, setTaxId] = useState('');
    const [taxes, setTaxes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [branchoffices, setBranchoffices] = useState([]);
    const [selectedBranchoffices, setSelectedBranchoffices] = useState([]);
    const [allBranches, setAllBranches] = useState(true);

    const token = localStorage.getItem("x-access-token");

    const getTaxes = async () => {
        try {
            const response = await TaxesFetchAPI.getTaxes(token);
            setTaxes(response.data.data || []);
        } catch (err) {
            console.log(err);
            setTaxes([]);
        }
    };

    const openModal = () => {
        const user = JSON.parse(localStorage.getItem('user'));

        setShowModal(true);
        setBranchoffices(user?.branchoffices || []);
        setAllBranches(true);
        setSelectedBranchoffices([]);
        getTaxes();
    };


    const toggleBranch = (branchId) => {
        setAllBranches(false);

        setSelectedBranchoffices((prev) => {
            if (prev.includes(branchId)) {
                return prev.filter(id => id !== branchId);
            }

            return [...prev, branchId];
        });
    };

    const selectAllBranches = () => {
        setAllBranches(true);
        setSelectedBranchoffices([]);
    };

    const submit = async (e) => {
        e.preventDefault();

        const user = JSON.parse(localStorage.getItem('user'));

        if (!productsFile) {
            return ErrorAlert('', 'Debes subir el Excel de productos', 'warning');
        }

        if (!taxId) {
            return ErrorAlert('', 'Debes seleccionar un impuesto', 'warning');
        }

        if (!allBranches && selectedBranchoffices.length === 0) {
            return ErrorAlert('', 'Debes seleccionar al menos una sucursal o aplicar a todas', 'warning');
        }

        const formData = new FormData();
        formData.append('products_file', productsFile);
        if (optionalsFile) {
            formData.append('optionals_file', optionalsFile);
        }
        formData.append('tax_id', taxId);
        formData.append('apply_all_branchoffices', allBranches ? '1' : '0');

        if (!allBranches) {
            formData.append('branchoffice_ids', JSON.stringify(selectedBranchoffices));
        }

        try {
            setLoading(true);

            await ExcelModuleFechtAPI.UploadBusinessGroup(
                user.business_id,
                formData,
                token
            );

            ErrorAlert('', 'Menú importado con éxito', 'success');

            setProductsFile(null);
            setOptionalsFile(null);
            setTaxId('');
            setEventHandler(1);
            setShowModal(false);
        } catch (err) {
            ErrorAlert(
                err?.response?.data?.message || err?.response?.data?.error,
                'Error al importar el menú',
                'error'
            );
        } finally {
            setLoading(false);
        }
    };

    //Function to download the products template
    const downloadProductsTemplate = async () => {
        let error = false;
        try {
            await ExcelModuleFechtAPI.DownloadTemplateGroups(token);
        } catch (err) {
            error = true;
        }
        //We show a error alert
        if (error) {
            ErrorAlert('No se pudo descargar el template de productos', 'Error de descarga', 'error');
        }
    }

    const downloadOptionalsTemplate = async () => {
        let error = false;
        try {
            await ExcelModuleFechtAPI.DownloadTemplateOptionals(token);
        } catch (err) {
            error = true;
        }
        //We show a error alert
        if (error) {
            ErrorAlert('No se pudo descargar el template de modificadores', 'Error de descarga', 'error');
        }
    }

    return (
        <>
            <button
                className="btn btn-dark btn-sm fw-normal bg-body text-dark border border-1 rounded-2"
                onClick={openModal}
                type="button"
            >
                <i className="uil uil-airplay"> </i>
                Importar menú
            </button>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <h3>
                        <i className="uil uil-airplay"></i>
                        Importar menú
                    </h3>
                </Modal.Header>

                <Modal.Body>
                    <div className="mb-4 p-3 border rounded-3 bg-light">
                        <h6 className="fw-bold mb-2">Instrucciones para importar el menú</h6>

                        <p className="mb-2">
                            Descarga las plantillas, llena la información y luego súbelas en este modal.
                        </p>

                        <div className="d-flex gap-2 mb-3 flex-wrap">
                            <button
                                className="btn btn-success btn-sm"
                                target="_blank"
                                rel="noreferrer"
                                onClick={downloadProductsTemplate}
                            >
                                Descargar plantilla de productos
                            </button>

                            <button
                                className="btn btn-outline-success btn-sm"
                                target="_blank"
                                rel="noreferrer"
                                onClick={downloadOptionalsTemplate}
                            >
                                Descargar plantilla de modificadores
                            </button>
                        </div>

                        <div className="small text-muted">
                            <p className="mb-1">
                                <strong>Plantilla de productos:</strong> aquí colocas las categorías, productos, precios y SKU.
                            </p>
                            <p className="mb-1">
                                <strong>Sección:</strong> será la categoría del producto. Si repites la misma sección, los productos quedarán en esa misma categoría.
                            </p>
                            <p className="mb-1">
                                <strong>SKU:</strong> es el código único del producto. Este SKU se usa para conectar los modificadores.
                            </p>
                            <p className="mb-1">
                                <strong>Plantilla de modificadores:</strong> es opcional. Úsala solo si los productos tienen grupos de opciones.
                            </p>
                            <p className="mb-0">
                                <strong>SKU Producto:</strong> debe coincidir con el SKU del producto en la plantilla de productos.
                            </p>
                        </div>
                    </div>

                    <Form onSubmit={submit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Plantilla de productos</Form.Label>
                            <Form.Control
                                type="file"
                                accept=".xlsx,.xls"
                                onChange={(e) => setProductsFile(e.target.files[0])}
                            />
                            <small className="text-muted">
                                Obligatoria. Contiene categorías, productos, precios y SKU.
                            </small>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Plantilla de modificadores</Form.Label>
                            <Form.Control
                                type="file"
                                accept=".xlsx,.xls"
                                onChange={(e) => setOptionalsFile(e.target.files[0])}
                            />
                            <small className="text-muted">
                                Opcional. Súbela solo si tus productos tienen opciones, acompañantes o modificadores.
                            </small>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Sucursales a aplicar</Form.Label>

                            <div className="border rounded-3 p-3">
                                <Form.Check
                                    type="checkbox"
                                    id="all-branches-import"
                                    label="Aplicar a todas las sucursales"
                                    checked={allBranches}
                                    onChange={selectAllBranches}
                                    className="mb-2"
                                />

                                <div className="d-flex flex-column gap-2 mt-2">
                                    {branchoffices.map((branch, index) => {
                                        const branchId = branch.branchoffice_id || branch.id;

                                        return (
                                            <Form.Check
                                                key={branchId || index}
                                                type="checkbox"
                                                id={`branch-import-${branchId}`}
                                                label={branch.branchoffice_name || branch.name}
                                                checked={!allBranches && selectedBranchoffices.includes(branchId)}
                                                onChange={() => toggleBranch(branchId)}
                                            />
                                        );
                                    })}
                                </div>
                            </div>

                            <small className="text-muted">
                                Si seleccionas todas, el cambio se aplicará a todas las sucursales de la empresa.
                            </small>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Impuesto</Form.Label>
                            <Form.Select
                                value={taxId}
                                onChange={(e) => setTaxId(e.target.value)}
                            >
                                <option value="">Seleccione un impuesto</option>

                                {taxes.map((tax) => (
                                    <option key={tax.id} value={tax.id}>
                                        {tax.tax} - {tax.percentage}
                                    </option>
                                ))}
                            </Form.Select>
                            <small className="text-muted">
                                Este impuesto se aplicará a todos los productos importados.
                            </small>
                        </Form.Group>

                        <div className="d-flex justify-content-between">
                            <Button
                                size="sm"
                                variant="secondary"
                                onClick={() => setShowModal(false)}
                                disabled={loading}
                            >
                                Cerrar
                            </Button>

                            <Button
                                size="sm"
                                variant="success"
                                type="submit"
                                disabled={loading}
                            >
                                {loading ? 'Importando...' : 'Guardar'}
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ModalImport;